/* Generated rules are supplied by BEDZ OS. Shopify validates the free base at checkout. */
(function () {
  'use strict';
  const campaign = window.BedzMlilyPromotion;
  if (!campaign) return;
  const numeric = id => String(id).split('/').pop();
  const rules = new Map(campaign.rules.flatMap(r => r.mattressVariantIds.map(id => [numeric(id), r])));
  const active = () => Date.now() >= Date.parse(campaign.startsAt) && Date.now() < Date.parse(campaign.endsAt);
  const root = window.Shopify?.routes?.root || '/';
  let busy = false;
  async function request(path, data) {
    const response = await fetch(root + path, data ? {method:'POST', headers:{'Content-Type':'application/json'},body:JSON.stringify(data)} : {});
    const result = await response.json();
    if (!response.ok) throw Error(result.description || 'Unable to add your included base. Please contact BEDZ.');
    return result;
  }
  function eligible(cart) { return cart.items.find(i => rules.has(String(i.variant_id))); }
  async function reconcile() {
    let cart = await request('cart.js');
    const mattress = active() && eligible(cart);
    const selectedRule = mattress && rules.get(String(mattress.variant_id));
    const desired = selectedRule && numeric(selectedRule.baseVariantId);
    const baseQuantity = selectedRule?.baseQuantity || 1;
    const updates = {};
    let found = false;
    for (const item of cart.items) {
      if (item.properties?._bedz_promotion !== campaign.id) continue;
      if (desired && String(item.variant_id) === desired && !found) { updates[item.key] = baseQuantity; found = true; }
      else updates[item.key] = 0;
    }
    if (Object.keys(updates).length) cart = await request('cart/update.js', {updates});
    const existingQuantity = cart.items.filter(i => String(i.variant_id) === desired).reduce((n,i)=>n+i.quantity,0);
    if (desired && !found && existingQuantity < baseQuantity) {
      await request('cart/add.js', {items:[{id:desired, quantity:baseQuantity-existingQuantity, properties:{_bedz_promotion:campaign.id}}]});
      return true;
    }
    return Object.keys(updates).some(key => cart.items.find(i => i.key === key)?.quantity !== updates[key]);
  }
  async function addWithBase(event) {
    if (event.type === 'click' && !event.target.closest('button[type=submit],input[type=submit],button:not([type])')) return;
    const form = event.type === 'submit' ? event.target : event.target.closest('form');
    if (!(form instanceof HTMLFormElement) || !/\/cart\/add(?:\.js)?(?:\?|$)/.test(new URL(form.action).pathname)) return;
    const data = new FormData(form), rule = rules.get(String(data.get('id')));
    if (!active() || !rule || data.get('selling_plan')) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (busy) return;
    busy = true;
    const button = event.submitter || event.target.closest('button,input[type=submit]'); if (button) button.disabled = true;
    try {
      const cart = await request('cart.js');
      const id = String(data.get('id'));
      const quantity = Math.max(1, parseInt(data.get('quantity') || '1', 10));
      const properties = {};
      for (const [key,value] of data) { const match = key.match(/^properties\[(.+)\]$/); if (match) properties[match[1]] = value; }
      const items = [{id,quantity,properties}];
      const existing = eligible(cart), selectedRule = existing ? rules.get(String(existing.variant_id)) : rule;
      const base = numeric(selectedRule.baseVariantId);
      if (!cart.items.some(i => i.properties?._bedz_promotion === campaign.id || String(i.variant_id) === base)) items.push({id:base,quantity:selectedRule.baseQuantity || 1,properties:{_bedz_promotion:campaign.id}});
      await request('cart/add.js',{items});
      window.location.assign(root + 'cart');
    } catch (error) { window.alert(error.message); }
    finally { busy = false; if (button) button.disabled = false; }
  }
  document.addEventListener('submit',addWithBase,true);
  document.addEventListener('click',addWithBase,true);
  function init() {
    if (active()) {
      document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
        const refresh = () => {
          const applies = rules.has(String(new FormData(form).get('id')));
          let notice = form.querySelector('[data-bedz-free-base-note]');
          if (!notice) { notice = document.createElement('p'); notice.dataset.bedzFreeBaseNote = ''; notice.setAttribute('role','status'); form.prepend(notice); }
          notice.textContent = applies ? 'Deal of the Week: your matching adjustable base is added free with this mattress. One per order. Ends October 30.' : '';
          form.querySelectorAll('.shopify-payment-button').forEach(button => {button.hidden = applies; button.style.display = applies ? 'none' : '';});
        };
        refresh(); form.addEventListener('change',refresh);
      });
    }
    if (/\/cart\/?$/.test(location.pathname)) {
      const note = document.createElement('p'); note.setAttribute('role','status'); note.style.cssText='padding:16px;background:#edf4f1;color:#173c40;';
      note.textContent = 'MLILY free-base offer: one matching base per order. The qualifying mattress must remain in your cart. Discount applies automatically; no code needed.';
      (document.querySelector('main') || document.querySelector('.main-content') || document.body).prepend(note);
      reconcile().then(changed => {if(changed) location.reload();}).catch(error => {note.textContent = error.message;});
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
